import data from './generated/locations.json';

const rows = data.rows;

export const geo = Object.fromEntries(
  rows
    .filter((row) => row.rings)
    .map((row) => [
      String(row.id),
      { properties: { nazev: row.name, kod: row.id }, coordinates: row.rings },
    ])
);

/**
 * Street polylines keyed by row id. Loaded lazily (only the preview page
 * awaits this), so the ~3.2MB stays out of the main page bundle.
 * @type {Promise<Record<string, number[][][]>>}
 */
export const streetLinesPromise = import('./generated/street-lines.json').then(
  (module) => module.default
);

const byTag = (tag) =>
  Object.fromEntries(
    rows.filter((row) => row.tags === tag).map((row) => [row.id, [row.name, row.tags]])
  );

export const filterLocations = {
  districts: byTag('district'),
  city_parts: byTag('city_part'),
  cad_communities: byTag('cad_community'),
  all: Object.fromEntries(rows.map((row) => [row.id, [row.name, row.tags || 'city']])),
};